<template>
    <main class="home privacy-policy">
        <div class="wrapper">
            <h1 class="home__title">
                Polityka prywatności Serwisu
                <router-link to="/">www.racer-online.pl</router-link>
            </h1>
            <ol class="privacy-policy__list">
                <li>
                    <h3 class="home__title">Informacje ogólne.</h3>
                </li>
                <ol>
                    <li>
                        Operatorem Serwisu
                        <router-link to="/">www.racer-online.pl</router-link>
                        jest firma WHITE SOLUTION Sp. z o.o. Sp. k. z siedzibą w Łodzi przy ul.
                        Traugutta 5/4, 90-106 wpisaną do rejestru prowadzonego przez Sąd Rejonowy Łodzi-Śródmieścia w
                        Łodzi, XX Wydział
                        Krajowego Rejestru Sądowego, pod nr KRS 0000724543, NIP: 725-226-66-75
                    </li>
                    <li>Serwis realizuje funkcje pozyskiwania informacji o Użytkownikach i ich zachowaniu w następujący
                        sposób:
                    </li>
                    <ol>
                        <li>poprzez dobrowolnie wprowadzone w formularzach informacje.</li>
                        <li>poprzez zapisywanie w urządzeniach końcowych pliki cookie (tzw. "ciasteczka").</li>
                        <li>
                            poprzez gromadzenie logów serwera www przez operatora hostingowego Home.pl S.A.,
                            funkcjonującego pod adresem
                            <a href="www.home.pl">www.home.pl</a>.
                        </li>
                    </ol>
                </ol>

                <li>
                    <h3 class="home__title">Informacje w formularzach.</h3>
                </li>
                <ol>
                    <li>Serwis zbiera informacje podane dobrowolnie przez Użytkownika.</li>
                    <li>Serwis może zapisać ponadto informacje o parametrach połączenia (oznaczenie czasu, adres IP).
                    </li>
                    <li>Dane podane w formularzach są przetwarzane na warunkach przewidzianych w Regulaminie Serwisu.
                    </li>
                </ol>

                <li>
                    <h3 class="home__title">Informacja o plikach cookies.</h3>
                </li>
                <ol>
                    <li>Serwis korzysta z plików cookies.</li>
                    <li>
                        Pliki cookies (tzw. „ciasteczka”) stanowią dane informatyczne, w szczególności pliki tekstowe,
                        które
                        przechowywane są w urządzeniu końcowym Użytkownika Serwisu i przeznaczone są do korzystania ze
                        stron internetowych
                        Serwisu. Cookies zazwyczaj zawierają nazwę strony internetowej, z której pochodzą, czas
                        przechowywania ich na
                        urządzeniu końcowym oraz unikalny numer.
                    </li>
                    <li>
                        Podmiotem zamieszczającym na urządzeniu końcowym Użytkownika Serwisu pliki cookies oraz
                        uzyskującym do nich
                        dostęp jest operator Serwisu.
                    </li>
                    <li>Pliki cookies wykorzystywane są w następujących celach:</li>
                    <ol>
                        <li>
                            tworzenia statystyk, które pomagają zrozumieć, w jaki sposób Użytkownicy Serwisu korzystają
                            ze stron
                            internetowych, co umożliwia ulepszanie ich struktury i zawartości;
                        </li>
                        <li>
                            utrzymanie sesji Użytkownika Serwisu (po zalogowaniu), dzięki której Użytkownik nie musi na
                            każdej podstronie
                            Serwisu ponownie wpisywać loginu i hasła;
                        </li>
                        <li>
                            określania profilu Użytkownika w celu wyświetlania mu dopasowanych materiałów w sieciach
                            reklamowych, w
                            szczególności sieci Google.
                        </li>
                    </ol>
                    <li>
                        W ramach Serwisu stosowane są dwa zasadnicze rodzaje plików cookies: „sesyjne” (session cookies)
                        oraz „stałe”
                        (persistent cookies). Cookies „sesyjne” są plikami tymczasowymi, które przechowywane są w
                        urządzeniu końcowym
                        Użytkownika do czasu wylogowania, opuszczenia strony internetowej lub wyłączenia oprogramowania
                        (przeglądarki
                        internetowej). „Stałe” pliki cookies przechowywane są w urządzeniu końcowym Użytkownika przez
                        czas określony w
                        parametrach plików cookies lub do czasu ich usunięcia przez Użytkownika.
                    </li>
                    <li>
                        Oprogramowanie do przeglądania stron internetowych (przeglądarka internetowa) zazwyczaj
                        domyślnie dopuszcza
                        przechowywanie plików cookies w urządzeniu końcowym Użytkownika. Użytkownicy Serwisu mogą
                        dokonać zmiany ustawień
                        w tym zakresie. Przeglądarka internetowa umożliwia usunięcie plików cookies. Możliwe jest także
                        automatyczne
                        blokowanie plików cookies. Szczegółowe informacje na ten temat zawiera pomoc lub dokumentacja
                        przeglądarki
                        internetowej.
                    </li>
                    <li>
                        Ograniczenia stosowania plików cookies mogą wpłynąć na niektóre funkcjonalności dostępne na
                        stronach
                        internetowych Serwisu.
                    </li>
                    <li>
                        Pliki cookies zamieszczane w urządzeniu końcowym Użytkownika Serwisu i wykorzystywane mogą być
                        również przez
                        współpracujących z operatorem Serwisu reklamodawców oraz partnerów.
                    </li>
                    <li>
                        Zalecamy przeczytanie polityki ochrony prywatności tych firm, aby poznać zasady korzystania z
                        plików cookie
                        wykorzystywane w statystykach: <a href="https://marketingplatform.google.com/about/">Polityka
                        ochrony prywatności Google Analytics</a>.
                    </li>
                    <li>
                        Pliki cookie mogą być wykorzystane przez sieci reklamowe, w szczególności sieć Google, do
                        wyświetlenia reklam
                        dopasowanych do sposobu, w jaki Użytkownik korzysta z Serwisu. W tym celu mogą zachować
                        informację o ścieżce
                        nawigacji użytkownika lub czasie pozostawania na danej stronie.
                    </li>
                    <li>
                        W zakresie informacji o preferencjach Użytkownika gromadzonych przez sieć reklamową Google
                        użytkownik może
                        przeglądać i edytować informacje wynikające z plików cookies przy pomocy narzędzia:
                        <a href="https://www.google.com/ads/preferences/">https://www.google.com/ads/preferences/</a>
                    </li>
                </ol>

                <li>
                    <h3 class="home__title">Logi serwera.</h3>
                </li>
                <ol>
                    <li>
                        Informacje o niektórych zachowaniach Użytkowników podlegają logowaniu w warstwie serwerowej.
                        Dane te są
                        wykorzystywane wyłącznie w celu administrowania serwisem oraz w celu zapewnienia jak najbardziej
                        sprawnej obsługi
                        świadczonych usług hostingowych.
                    </li>
                    <li>Przeglądane zasoby identyfikowane są poprzez adresy URL. Ponadto zapisowi mogą podlegać:</li>
                    <ol>
                        <li>czas nadejścia zapytania,</li>
                        <li>czas wysłania odpowiedzi,</li>
                        <li>nazwę stacji klienta – identyfikacja realizowana przez protokół HTTP,</li>
                        <li>informacje o błędach jakie nastąpiły przy realizacji transakcji HTTP,</li>
                        <li>
                            adres URL strony poprzednio odwiedzanej przez Użytkownika (referer link) – w przypadku gdy
                            przejście do
                            Serwisu nastąpiło przez odnośnik,
                        </li>
                        <li>informacje o przeglądarce Użytkownika,</li>
                        <li>informacje o adresie IP.</li>
                    </ol>
                    <li>Dane powyższe nie są kojarzone z konkretnymi osobami przeglądającymi strony.</li>
                    <li>Dane powyższe są wykorzystywane jedynie dla celów administrowania serwerem.</li>
                </ol>

                <li>
                    <h3 class="home__title">Udostępnienie danych.</h3>
                </li>
                <ol>
                    <li>Dane podlegają udostępnieniu podmiotom zewnętrznym wyłącznie w granicach prawnie dozwolonych.
                    </li>
                    <li>Dane umożliwiające identyfikację osoby fizycznej są udostępniane wyłączenie za zgodą tej
                        osoby.
                    </li>
                    <li>
                        Operator może mieć obowiązek udzielania informacji zebranych przez Serwis upoważnionym organom
                        na podstawie
                        zgodnych z prawem żądań w zakresie wynikającym z żądania.
                    </li>
                </ol>
                <li>
                    <h3
                        class="home__title"
                    >Zarządzanie plikami cookies – jak w praktyce wyrażać i cofać zgodę?</h3>
                </li>
                <ol>
                    <li>
                        Jeśli Użytkownik nie chce otrzymywać plików cookies, może zmienić ustawienia przeglądarki.
                        Zastrzegamy, że
                        wyłączenie obsługi plików cookies niezbędnych dla procesów uwierzytelniania, bezpieczeństwa,
                        utrzymania
                        preferencji użytkownika może utrudnić, a w skrajnych przypadkach może uniemożliwić korzystanie
                        ze stron www.
                    </li>
                </ol>
            </ol>
        </div>
    </main>
</template>

<script>
export default {
    name: "PrivacyPolicy"
};
</script>

<style lang="scss">
.privacy-policy {
    a {
        color: #85b904;
        font-weight: bold;
    }

    &__list {
        > li {
            font-weight: bold;
            font-size: 20px;
        }

        ol {
            ol {
                list-style: lower-latin;
            }
        }
    }
}
</style>
